import { useState, useEffect, useRef } from "react";
import VerificationInput from "react-verification-input";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { connect } from "react-redux";

import { persianArabicToEnglish } from "Utils/UnicodeConvert";
// import SpinnerButton from "SharedComponents/SpinnerButton";
import LocalStoragekeys from "Constants/LocalStoragekeys";
import { getAccessToken, getProfile } from "Redux/Actions/AuthActions";

// import Pages from "Constants/Pages";
import "./styles.scss";

const Page = (props) => {
  const [phoneNumber] = useState(props?.location?.state);
  const [otpCode, setOtpCode] = useState("");
  const [timer, setTimer] = useState(60);
  const inputRef = useRef(null);
  const history = useHistory();
  let interval = null;

  useEffect(() => {
    // if (props.accessToken) {
    //     history.push(Pages.Main);
    // };
    timerCode();
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (otpCode.length === 6) {
      getToken();
    }
  }, [otpCode]);

  const timerCode = () => {
    setTimer(60);
    interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) clearInterval(interval);
        return prev - 1;
      });
    }, 1000);
  };

  const onClickSubmit = () => {
    inputRef.current.type = "tel";
    if (otpCode.length < 6) {
      toast("کد وارد شده کمتر از 6 عدد است", { type: "error" });
    } else {
      getToken();
    }
  };

  const getToken = () => {
    const params = {
      phoneNumber: persianArabicToEnglish(phoneNumber),
      code: persianArabicToEnglish(otpCode),
    };
    props
      .getAccessToken(params)
      .then((res) => {
        // const show_referral = localStorage.getItem(
        //   LocalStoragekeys.Show_Referral
        // );
        // if (show_referral === "true") {
        //   history.push(Pages.ReferralCode);
        // } else {
        //   history.push(Pages.Main);
        // }

        history.push("/");
        // props.getProfile();
      })
      .catch((err) => {
        inputRef.current.value = "";
        // inputRef.current.state.tan = "";
        setOtpCode("");
      });
  };

  const onClickChangePhoneNumber = () => {
    history.push("/sign-in");
  };

  const alertNotFinishTime = () => {
    toast(`لطفاً بعد از ${timer} ثانیه دیگر تلاش کنید`, { type: "error" });
  };

  return (
    <div className="otp-screen" style={{ height: window.innerHeight }}>
      <p className="otp-screen-send-code">
        هم اکنون یک کد 6 رقمی برای شماره{" "}
        <span className="otp-screen-send-code-span text-dap-blue">
          {phoneNumber}
        </span>{" "}
        ارسال شد
      </p>
      <p className="sigin-screen-inter-phone-text">
        کد را در این قسمت وارد کنید
      </p>

      {/* <VerificationInput
        lenght={6}
        autoFocus={true}
        removeDefaultStyles={true}
        ref={inputRef}
        value={otpCode}
        className="otps  d-flex"
        validChars={["0-9", "۰-۹"]}
        container={{ className: "container-characters" }}
        characters={{ className: "characters" }}
        character={{
          className: "character",
          classNameInactive: "character--inactive",
          classNameSelected: "character--selected",
        }}
        onChange={(value) => setOtpCode(value)}
        // input={{ onChange: (value) => setOtpCode(value) }}
      /> */}
      <VerificationInput
        removeDefaultStyles
        lenght={6}
        autoFocus={true}
        removeDefaultStyles={true}
        ref={inputRef}
        value={otpCode}
        validChars={["0-9", "۰-۹"]}
        onChange={(value) => setOtpCode(value)}
        classNames={{
          container: "container",
          character: "character",
          characterInactive: "character--inactive",
          characterSelected: "character--selected",
        }}
      />
      <button
        className="sigin-screen-btn  bg-dap-success"
        onClick={onClickSubmit}
      >
        ادامه
      </button>
      {/* <SpinnerButton
        className="sigin-screen-btn"
        onClick={onClickSubmit}
        text="ادامه"
      /> */}
      <div
        className="otp-screen-btn-retry"
        onClick={timer === 0 ? timerCode : alertNotFinishTime}
      >
        {timer === 0 ? "تلاش مجدد" : timer}
      </div>
      <p
        className="text-center otp-screen-change-phone 
        "
        onClick={onClickChangePhoneNumber}
      >
        تغییر شماره موبایل
      </p>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    accessToken: state.auth.accessToken,
  };
}
export default connect(mapStateToProps, { getAccessToken, getProfile })(Page);
